import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popover from 'react-bootstrap/Popover';
import styled, { css } from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { DESKTOP, MOBILE_LANDSCAPE } from 'src/client/constants/mediaQueries';

export const NavbarIcon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  vertical-align: middle;
  text-decoration: none;

  :hover & {
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};
  }
`;

export const ImageButton = styled.div`
  transition: 0.3s color;
  color: ${(props) => props.theme.headerBarPrimary2};
  position: relative;
  vertical-align: baseline;
  padding: 5px;
  text-align: center;

  @media ${MOBILE_LANDSCAPE} {
    padding: 7px;
  }

  @media ${DESKTOP} {
    padding: 10px;
  }

  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};

    ${NavbarIcon} {
      text-decoration: none;
      color: ${(props) => props.theme.headerBarPrimary4};
    }
  }

  i {
    transition: color 0.3s;
    vertical-align: middle;
  }
`;

export const FlatPopover = styled(Popover)`
  background: ${(props) => props.theme.primary1};
  border-color: ${(props) => props.theme.primary3};
  border-width: 1px;
  border-style: solid;
  border-radius: 2px;
  padding: 0;

  .popover-content {
    padding: 0;
  }
`;

export const MobileMenuIcon = styled(FontAwesomeIcon)`
  display: flex;
  font-size: 1.55rem;
  margin-right: 10px;
  width: 1.25em !important;
  height: 25px;
  align-items: center;

  path {
    width: 22px;
  }
`;

const menuNavLinkCSS = css`
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  align-self: stretch;
  padding: 0 10px;
  font-size: 12px;
  color: ${(props) => props.theme.headerBarPrimary2};
  transition: 0.3s color;
  white-space: nowrap;

  &:hover,
  &:focus {
    outline: none;
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};
  }

  &.active {
    outline: none;
    background-color: ${(props) => props.theme.headerBarPrimary3};
    color: ${(props) => props.theme.primaryBtn1Text};
  }

  @media ${DESKTOP} {
    padding: 0 10px;
  }
`;

export const MenuNavLink = styled(NavLink)`
  ${menuNavLinkCSS}
`;

export const MenuNavAnchor = styled.a`
  ${menuNavLinkCSS}
`;
